// eslint-disable-next-line
import state from "./state";

export default {
  getAllSavedValues: function(state) {
    return state.allSaved;
  },
  getAllCheckedValues: function(state) {
    return state.allChecked;
  },  
  getSearchHasResults: function(state) {
    return state.searchHasResults;
  },
  getHasExampleByNaics: function(state) {
    return state.hasExamplesByNaics;
  },
  getHasNoSelection: function(state) {
    return state.hasNoSelection;
  },
  getSavedTree: function(state) {
    return state.savedTree;
  },
  getReducedTree: function(state) {
    return state.reducedTree;
  },
  getSearchKeyword: function(state) {
    return state.keywordSaved;
  },
  getInitTree: function(state) {
    return state.initTree;
  },
  getLevelSelectable: function(state) {
    return state.levelSelectable;
  },
  getMapTopLevelNaics: function(state) {
    return state.mapTopLevelNaics;
  },
  getAlgoliaHitsResult: function(state) {
    return state.algoliaHitsResult;
  },   
  getAllIndustriesDirectus:function(state){
    return state.allIndustriesDirecturs;
  },
  getShowDetail: function(state) {
    return state.showDetail;
  },
  getNodeInfo: function(state) {
    return state.nodeInfo;
  }
};
